// Some global config for moment -- treat every interval as its unit right up to the next one
moment.relativeTimeThreshold('s', 60);
moment.relativeTimeThreshold('m', 60);
moment.relativeTimeThreshold('h', 24);
moment.relativeTimeThreshold('d', 30);
moment.relativeTimeThreshold('M', 12);

// relativeTime filter -- formats date/time string into a relative time much like moment().fromNow(), but with slightly more intelligence.
angular.module('app.filters').filter('relativeTime', ($filter) => {
  'ngInject';
  return (input) => {
    let t = moment(input);
    let val = t.fromNow();
    if (val.match(/days?$/)) {
      // If moment wants to say "day" or "days", it's possible that this could be rounded in a non-intuitive way.
      // The most intuitive thing for users is the number of midnights crossed between now and then. The easiest
      // way to get that is to set the time (not the date) of the moment in question to match the time of "now",
      // then let moment do its thing.
      let now = moment();
      t.hours(now.hours());
      t.minutes(now.minutes());
      t.seconds(now.seconds());
      t.millisecond(now.millisecond());
      val = t.fromNow();
    }
    return val;
  };
});



// WEBPACK FOOTER //
// ./app/filters/relative-time.js